import * as React from 'react';
import PropTypes from 'prop-types';

import SlideTitle from './SlideTitle';
import SlideSubTitle from './SlideSubTitle';
import SlideText from './SlideText';
import SlidePicture from './SlidePicture';
import Link from './Link';

/**
 * Story
 *
 * Ref is forwarded
 */

const Story = React.forwardRef(({ title, subTitle, text, picture, link, lightbox, pictureZoom }, ref) => {
  const slidePicture = React.useRef();

  const SubTitle = <SlideSubTitle subTitle={subTitle} tag={!title && 'h3'} />;
  return (
    <article ref={ref} className="story">
      {title && <SlideTitle title={title} color="blue-pale" />}
      {picture && <SlidePicture ref={slidePicture} picture={picture} alt={title} lightbox={lightbox} pictureZoom={pictureZoom} />}
      <div className="story-text">
        {subTitle && (
          <>
            {lightbox ? (
              <a
                href={lightbox}
                onClick={(event) => {
                  event.preventDefault();
                  slidePicture.current.open();
                }}
              >
                {SubTitle}
              </a>
            ) : (
              <>{SubTitle}</>
            )}
          </>
        )}
        {text && <SlideText text={text} />}
        {link && <Link url={link.url} title={link.title} />}
      </div>
    </article>
  );
});

Story.displayName = 'Story';

Story.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  text: PropTypes.string,
  picture: PropTypes.string,
  link: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    target: PropTypes.string,
  }),
  lightbox: PropTypes.string,
  pictureZoom: PropTypes.bool,
};

export default Story;
